import { render, staticRenderFns } from "./webpage-seo.vue?vue&type=template&id=755262ba&"
import script from "./webpage-seo.vue?vue&type=script&lang=js&"
export * from "./webpage-seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports